export const FigmaIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3217_3064)">
      <path d="M5.83371 14.6666C7.02947 14.6666 7.99995 13.6711 7.99995 12.4444V10.2222H5.83371C4.63795 10.2222 3.66748 11.2177 3.66748 12.4444C3.66748 13.6711 4.63795 14.6666 5.83371 14.6666Z" fill="#0ACF83"/>
      <path d="M3.66748 8.00005C3.66748 6.77339 4.63795 5.77783 5.83371 5.77783H7.99995V10.2223H5.83371C4.63795 10.2223 3.66748 9.22672 3.66748 8.00005Z" fill="#A259FF"/>
      <path d="M3.66748 3.55572C3.66748 2.32905 4.63795 1.3335 5.83371 1.3335H7.99995V5.77794H5.83371C4.63795 5.77794 3.66748 4.78239 3.66748 3.55572Z" fill="#F24E1E"/>
      <path d="M8 1.3335H10.1662C11.362 1.3335 12.3325 2.32905 12.3325 3.55572C12.3325 4.78239 11.362 5.77794 10.1662 5.77794H8V1.3335Z" fill="#FF7262"/>
      <path d="M12.3325 8.00005C12.3325 9.22672 11.362 10.2223 10.1662 10.2223C8.97047 10.2223 8 9.22672 8 8.00005C8 6.77339 8.97047 5.77783 10.1662 5.77783C11.362 5.77783 12.3325 6.77339 12.3325 8.00005Z" fill="#1ABCFE"/>
    </g>
    <defs>
      <clipPath id="clip0_3217_3064">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
